import { render, staticRenderFns } from "./examineDistributorTemplate.vue?vue&type=template&id=4568c0fb&scoped=true"
import script from "./examineDistributorTemplate.vue?vue&type=script&lang=js"
export * from "./examineDistributorTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4568c0fb",
  null
  
)

export default component.exports